import { getImpersonator, getTokenSilently } from '../auth0'

const SDUI_SERVICE_URL = process.env.REACT_APP_SDUI_SERVICE_URL

function isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return regex.test(navigator.userAgent)
}

async function getAuthorizationHeaders() {
  const impersonator = getImpersonator()
  if (impersonator) {
    return {
      'x-cook-impersonation-secret': impersonator.secret,
      'x-cook-impersonation-email': impersonator.email
    }
  }
  const token = await getTokenSilently()
  return {
    Authorization: token ? `${token}` : ''
  }
}

export const fetchOrdersSwimlanes = async () => {
  const token = await getTokenSilently()

  const headers = {
    Authorization: token ? `${token}` : '',
    platform: isMobile() ? `mobile-web` : 'web'
  }
  return fetch(`${SDUI_SERVICE_URL}/view/ordersPage`, { headers })
}

export const fetchUserPreferencesData = async () => {
  const headers = {
    platform: isMobile() ? `mobile-web` : 'web',
    ...(await getAuthorizationHeaders())
  }
  return fetch(`${SDUI_SERVICE_URL}/preferences`, { headers })
}

export const fetchUserProfilesPreferences = async () => {
  const headers = {
    platform: isMobile() ? `mobile-web` : 'web',
    ...(await getAuthorizationHeaders())
  }
  return fetch(`${SDUI_SERVICE_URL}/preferences/userProfiles`, { headers })
}

export const saveUserPreferencesData = async payload => {
  const headers = {
    platform: isMobile() ? `mobile-web` : 'web',
    'Content-type': 'application/json',
    ...(await getAuthorizationHeaders())
  }
  return fetch(`${SDUI_SERVICE_URL}/preferences/updatePreferences`, {
    headers,
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export const removeUserProfileRequest = async payload => {
  const headers = {
    platform: isMobile() ? `mobile-web` : 'web',
    'Content-type': 'application/json',
    ...(await getAuthorizationHeaders())
  }
  return fetch(`${SDUI_SERVICE_URL}/preferences/removeProfile`, {
    headers,
    method: 'POST',
    body: JSON.stringify(payload)
  })
}
